import Verification from './lib/verification';

export default new Verification();
